import React, { useEffect } from 'react';
import { useStateValue } from './AppContext.jsx';
import AnimalSlider from './AnimalSlider.jsx';
import {makeBreedString, makeAgeString, updateHash, getAnimals} from './AnimalFunctions.jsx';


function AnimalModal() {
  const [ context, dispatch ] = useStateValue();

  //load animal when requested
  useEffect(() => {
    async function fetchData(){
      let animal_id = parseInt(window.location.hash.replace("#", ""));

      if(animal_id){
        let fetch = getAnimals(context.siteBase, {animal_id: animal_id});
        fetch
          .then(results => {
            dispatch({
              type: 'makeActiveAnimal',
              animal: results.animals[0]
            })
          })
          .catch(() => {});
      }      
    }

    fetchData();
  }, [context.siteBase, dispatch]);

  //do AdoptMe integration
  useEffect(() => {
    var adoptmeWidgets = document.getElementsByClassName('adoptme_widget');

    if(
      adoptmeWidgets.length
      && typeof window.adoptmeapp_widget_check_status === "function"
      ){
      window.adoptmeapp_widget_check_status(adoptmeWidgets[0]);
    }
  })

  //show nothing if there's no active animal
  if(!context.activeAnimal){
    //if there's an animal ID in the hash, try to load it
    return (<div></div>);
  }

  let {activeAnimal} = context;

  let breed = makeBreedString(activeAnimal);
  let age = makeAgeString(activeAnimal);

  //on load, set the window hash
  updateHash(activeAnimal.animal_id);

  let closeModal = function(){
    updateHash(false);
    dispatch({type: 'unmakeActiveAnimal'})    
  }

  let shareAttribute = "return addthis_open(this, '', 'https://eastbayspca.org/adoptions/pet-details/"+ activeAnimal.animal_id +"', 'East Bay SPCA Animal Details - "+ activeAnimal.name +"')"

  let shareHover = (e) => {
    window.addthis_open(
      e.target,
      '',
      'https://eastbayspca.org/adoptions/pet-details/'+ activeAnimal.animal_id,
      'East Bay SPCA Animal Details - ' + activeAnimal.name
      );
  }

  let shareOff = () => {
    window.addthis_close();
  }

  let shareClick = () => {
    window.addthis_sendto();
  }

  return (
    <div 
      className="animalModal_container"
      >
      <aside 
        className="animalModal_overlay"
        onClick={closeModal}
        />
      <div
        className="animalModal"
        id={activeAnimal.id}
        >
        <h1 className="animalModal_name notranslate">{activeAnimal.name}</h1>
        <div className="animalModal_summary">
          <AnimalSlider photos={activeAnimal.photos} videos={activeAnimal.videos}  />
          <div
            className="animalModal_info"
            >
            <p className="animal_info_row">
              <span className="animal_info_key">Animal Id:</span>
              <span className="animal_info_value notranslate">{activeAnimal.animal_id}</span>
            </p>
            <p className="animal_info_row">
              <span className="animal_info_key">Species:</span>
              <span className="animal_info_value notranslate">{activeAnimal.species}</span>
            </p>
            <p className="animal_info_row">
              <span className="animal_info_key">Sex:</span>
              <span className="animal_info_value notranslate">{activeAnimal.sex}</span>
            </p>
            <p className="animal_info_row">
              <span className="animal_info_key">Age:</span>
              <span className="animal_info_value notranslate">{age} (approx)</span>
            </p>
            {
              activeAnimal.weight &&
              <p className="animal_info_row">
                <span className="animal_info_key">Weight:</span>
                <span className="animal_info_value notranslate">{activeAnimal.weight}</span>
              </p>
            }
            <p className="animal_info_row">
              <span className="animal_info_key">Location:</span>
              <span className="animal_info_value notranslate">{activeAnimal.location}</span>
            </p>
            <p className="animal_info_row lost_found_location">
              <span className="animal_info_key">Lost/Found Location:</span>
              <span className="animal_info_value notranslate">{activeAnimal.lf_city}</span>
            </p>
            {
              activeAnimal.icons &&
              <p className="animal_info_row icons icons">
              {
                activeAnimal.icons.map((icon, index) => (
                    <div key={index} className="animal_info_value notranslate">{icon}</div>
                ))
              }
              </p>
            }             
          </div>
          <button
            className="animalModal_close"
            onClick={closeModal}>&times;</button>
        </div>
        <div className="animalModal_description"><p dangerouslySetInnerHTML={{ __html: activeAnimal.description.replace(/\n/g,'<br><br>')}}></p></div>
        {
          context.addons.adoptmeapp && context.addons.adoptmeapp.shelter ?
          (
          <div 
            widget-width='auto'
            widget-height='600'
            className='adoptme_widget'
            widget-shelter={context.addons.adoptmeapp.shelter}
            widget-animal_id={activeAnimal.animal_id}></div>
          ) : React.Fragment
        }
      </div>
    </div>
  );
}

export default AnimalModal;